import Vue from 'vue';
import { Component, Prop, Watch, Emit } from 'vue-property-decorator';

@Component
export class Input extends Vue {
    @Prop({ default: '' }) readonly type!: string;

    @Prop({ default: '' }) readonly label!: string;

    @Prop({ default: '' }) readonly rules!: string;

    @Prop({ default: '' }) readonly description!: string;

    @Prop({ default: '' }) readonly name!: string;

    @Prop({ default: false }) readonly isLast!: boolean;

    @Prop({ default: '' }) readonly placeholder!: string;

    // @ts-ignore
    localValue = this.value;

    get labelText() {
        if (this.label.length > 0) {
            return this.label;
        }

        if (this.$te(`forms.labels.${this.name}`)) {
            return this.$t(`forms.labels.${this.name}`);
        }

        return false;
    }

    get placeholderText() {
        if (this.placeholder.length > 0) {
            return this.placeholder;
        }

        if (this.$te(`forms.placeholders.${this.name}`)) {
            return this.$t(`forms.placeholders.${this.name}`);
        }

        return false;
    }

    get descriptionText() {
        if (this.description.length > 0) {
            return this.description;
        }

        if (this.$te(`forms.descriptions.${this.name}`)) {
            return this.$t(`forms.descriptions.${this.name}`);
        }

        return false;
    }

    @Emit('input')
    update() {
        return this.localValue;
    }
}
